<!-- Copyright (c) 2019-2023 Cigent Technology Inc. All Rights Reserved. -->
<mat-card appearance="raised" class="top-n-threats-wrapper">
    <div>
        <p class="component-label">
          <span class="draggable">{{fTopTitle}}</span>
          <a [routerLink]="['/history']" [queryParams]="getHeaderQueryParams()">
            <span class="mdi mdi-open-in-new open-icon link"></span>
          </a>
        </p>
        <hr>
        <div *ngIf="dashboardTopNThreatsLoaded">
            <span class="dashboard-top-n-threats-loaded"></span>
        </div>
    </div>
    <div class="icon-and-list">
        <div class="icon-area">
            <span class="mdi mdi-bullseye-arrow icon"></span>
        </div>
        <div *ngIf="topNList != null; else skeletonLoader" class="list-area">
            <ul>
                <li class="list-item" *ngFor="let n of topNList; let i=index" id="threat">
                    <div class="list-info">
                        <span class="item-label" id="threat-name-{{i}}">{{ n.name }}</span>
                        <span class="item-value item-color"><a attr.aria-label="{{ n.name }} {{ n.threatCount }}" class="href-link" id="threat-count-{{i}}" [routerLink]="['/history']" [queryParams]="n.historyParams">{{ n.threatCount }}</a></span>
                    </div>
                </li>
                <li class="list-item" *ngIf="topNList.length == 0">
                    <span class="item-label" style="font-style: italic;">{{fTopNone}}</span>
                </li>
            </ul>
        </div>
        <ng-template #skeletonLoader>
          <div style="width: 63.75%">
            <ngx-skeleton-loader
              count="5"
              appearance="line"
              [theme]="{
                  display: 'flex',
                  height: '20px',
                  width: 'inherit',
                  margin: '11px auto -5px 18px',
                }">
            </ngx-skeleton-loader>
          </div>
      </ng-template>

    </div>

</mat-card>
